module.exports = __webpack_public_path__ + "img/carrier.d9214674.svg";